import addChartIcon from '@/../img/add-a-chart-icon.svg';
import { Dropdown, Tooltip } from 'rsuite';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';

// TODO: Move this whole file to menu module

export const SpaceBetweenWrapper = styled.div`
  margin-top: ${cssVars.dashboardMarginTop};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  min-height: 2px;
`;

export const StyledTooltip = styled(Tooltip)`
  .rs-tooltip-arrow {
    display: none;
  }

  .rs-tooltip-inner {
    background-color: #101938;
    opacity: 0.8;
    height: 28px;

    display: flex;
    align-items: center;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  .rs-dropdown-toggle {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .rs-dropdown-toggle-caret {
    top: 0;
  }
`;

export const ChangeCityWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 66px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const AddChartIcon = styled(addChartIcon)`
  width: 24px;
  height: 24px;
  padding-top: 3px;
  padding-left: 3px;
`;

export const StyledBalloon = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
`;

export const StyledDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
